import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import axios from "axios";

import App from "./App";

// API base URL for dev or production
// In production, Firebase Hosting rewrites /api/** to Cloud Run cm-backend
// In development, proxy to local backend on port 8080
axios.defaults.baseURL =
  process.env.REACT_APP_API_URL || "";
axios.defaults.headers.post["Content-Type"] = "application/json";

// Token auto-attach
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle unauthorized responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Redirect to login if not already there
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// ✅ Stale-UI guard: purge any lingering service workers and caches.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
}
if (window.caches && typeof window.caches.keys === 'function') {
  window.caches.keys()
    .then((keys) => Promise.all(keys.map((k) => window.caches.delete(k))))
    .catch(() => {});
}

const container = document.getElementById("root");
if (!container) {
  console.error("Root element not found!");
} else {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </Router>
    </React.StrictMode>
  );
}
